var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g(_vm._b({staticStyle:{"min-width":"80px"},attrs:{"type":"primary","size":"small"}},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('jj-icons',{attrs:{"type":"import"}}),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('buttons.import'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }